import { Application, Content, Device, User } from './'

export class Group {
  public _id: string
  public createdAt: number
  public updatedAt: number
  public description: string
  public name: string
  public devices: Device[]
  public contents: Content[]
  public c3apps: Application[]
  public users: User[]
  public children: Group[]
  public parent
  public path
}
